<!--
 * @Description: Jerry Create File
 * @Version: 1.0
 * @Autor: Jerry
 * @Date: 2022-01-07 08:55:32
 * @LastEditors: Jerry
 * @LastEditTime: 2022-01-17 11:17:27
-->
<template>
  <div class="activity-type">
    <template v-if="txt">
      <div class="left-txt" v-html="txt" />

    </template>
    <template v-else>
      <div class="left-txt" />
    </template>

    <div class="right-txt" @click="goMoreCutPage()">  去加购 ></div>
  </div>
</template>
<script>
import { LinkTypeCode } from '@/dictionary/base.js'
export default {
  name: 'ActivityTag',
  props: {
    txt: {
      type: [String, Number],
      default: () => {}
    },
    ActivityData: {
      type: Object,
      default: () => {}
    },
    activityCode: {
      type: [Number, String],
      default: () => ''
    }
  },
  data() {
    return {

    }
  },
  watch: {
    ActivityData: {
      // 商品数据源变动时，判断全选与反选的关系
      handler(val) {
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    goMoreCutPage() {
      const code = this.activityCode
      if (code == 8) {
        // this._jump(this._getTurnUrl(12), item.GoodSkuId)
        this.$router.push({
          name: LinkTypeCode.ActivitySeckillView,
          query: { id: this.ActivityData.ActivityId }
        })
      } else if (code == 3 || code == 4) {
        this.$router.push({
          name: LinkTypeCode.ActivityGiftView,
          params: { }
        })
      } else {
        this.$router.push({
          name: LinkTypeCode.ActivityView
        })
      }
    }
  }
}
</script>
<style scoped lang="less">
.type-reach-standard {
  margin: 0 4px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666F83;
}

.activity-type {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 32px 16px 60px;
  border-radius: 2px;
  padding: 6px 33px 6px 12px;
  width: 1108px;
  height: 26px;
  font-size: 14px;
  color: #111A34;
  background: #FFEEEC;

  .red-num {
    color: rgba(255, 57, 57, 1);
  }

  .gray-txt {
    color: rgba(102, 111, 131, 1);
  }

  .left-txt {
    display: flex;
    font-weight: bold;
  }

  .right-txt {
    font-size: 14px;
    color: rgba(255, 57, 57, 1);

    &:hover {
      cursor: pointer;
    }
  }
}
</style>
